import { db, AppSettings } from '../db';

const DEFAULT_SETTINGS: AppSettings = {
  id: 'local',
  retentionDays: 7
};

export const getSettings = async (): Promise<AppSettings> => {
  const settings = await db.settings.get('local');
  if (!settings) {
    return DEFAULT_SETTINGS;
  }
  return settings;
};

export const updateSettings = async (updates: Partial<AppSettings>): Promise<void> => {
  const currentSettings = await getSettings();
  const newSettings = {
    ...currentSettings,
    ...updates,
    id: 'local' as const
  };
  await db.settings.put(newSettings);
};
